module.exports = __webpack_public_path__ + "static/media/ASM.6d745c14.png";